import { Component, Input, OnChanges } from "@angular/core";
import { PaymentsService } from "src/services/payment/payments.service";

@Component({
  selector: "rc-payment-status-badge",
  templateUrl: "./payment-status-badge.component.html",
  styleUrls: ["./payment-status-badge.component.scss"],
  standalone: false,
})
export class PaymentStatusBadgeComponent implements OnChanges {
  @Input() public userId: string;

  public color = "gray";
  public text = "Loading...";

  constructor(private readonly paymentService: PaymentsService) {}

  public async ngOnChanges(): Promise<void> {
    if (!this.userId) {
      return;
    }

    const subscriptions = await this.paymentService.getUserStripeSubscriptions(this.userId);

    if (subscriptions.length === 0) {
      this.color = "gray";
      this.text = "No subscription";
    } else if (subscriptions.length === 1) {
      const subscription = subscriptions[0];

      if (subscription.status === "active") {
        this.color = "success";
        this.text = "Payment valid";
      } else {
        this.color = "danger";
        this.text = "Payment error";
      }
    } else {
      const numberOfSubscriptions = subscriptions.length;

      if (subscriptions.every((subscription) => subscription.status === "active")) {
        this.color = "success";
        this.text = `Payment valid for ${numberOfSubscriptions} subs`;
      } else if (subscriptions.every((subscription) => subscription.status !== "active")) {
        this.color = "danger";
        this.text = `Payment for ${numberOfSubscriptions} subs in error`;
      } else {
        this.color = "warning";
        this.text = `Some payment errors through ${numberOfSubscriptions} subs`;
      }
    }
  }
}
